@if (processingPurpose) {
    @if (processingPurpose.ID > 0) {
        <div class="detail-page-summary">
            <div class="row">
                <div class="col-6">
                    <div class="property"><b>{{ 'detailMain.summaryId' | t }}</b> {{ processingPurpose.ID }}</div>
                    <div class="property">
                        <b>{{ 'detailMain.summaryName' | t }}</b>&nbsp;<span data-uiid="dm-summary-name">{{
                            processingPurpose.name
                        }}</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="property">
                        <b>{{ 'detailMain.summaryDataSubject' | t }}</b> {{ processingPurpose.dataSubject || "None" }}
                    </div>
                    <div class="property">
                        <b>{{ 'detailMain.summaryMostRecentDpia' | t }}</b> {{ processingPurpose.dpiaDate | dateFormat }}
                    </div>
                </div>
            </div>
        </div>
    }
    <form [formGroup]="parentForm">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'detailMain.processingDetailsTitle' | t }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textfield
                                    [fieldLabel]="'detailMain.processingNameLabel' | t"
                                    dataUiid="dmdetailmain-processingname"
                                    identifier="name"
                                    formControlName="name"
                                    placeholder="Required"
                                ></cerrix-textfield>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-6">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.descriptionLabel' | t"
                                    dataUiid="dmdetailmain-description"
                                    identifier="description"
                                    formControlName="description"
                                ></cerrix-textarea>
                            </div>
                            <div class="form-group col-12 col-lg-6">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.purposeLabel' | t"
                                    dataUiid="dmdetailmain-purpose"
                                    identifier="purpose"
                                    formControlName="purpose"
                                ></cerrix-textarea>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.securityMeasuresLabel' | t"
                                dataUiid="dmdetailmain-securitymeasures"
                                identifier="securityMeasures"
                                formControlName="securityMeasures"
                            ></cerrix-textarea>
                        </div>

                        <div class="form-group">
                            <label for="basisId">{{ 'detailMain.basisLabel' | t }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-basis"
                                id="basisId"
                                formControlName="basisId"
                                prettyName="basis"
                                bindLabel="Name"
                                bindValue="ID"
                                [getDataMethod]="basisRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.explanationBasisLabel' | t"
                                dataUiid="dmdetailmain-explanation"
                                identifier="explanationBasis"
                                formControlName="explanationBasis"
                            ></cerrix-textarea>
                        </div>
                    </div>

                    <div class="col-12 col-xl-6 right-block">
                        <hr class="d-xl-none" />

                        <div class="form-group">
                            <label>{{ 'detailMain.organizationLabel' | t }}</label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-organization"
                                [getDataMethod]="organizationRequest"
                                formControlName="organizationId"
                                placeholder="Required"
                                [multiselect]="false"
                                (onChangeSingleId)="organizationChanged($event)"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="form-group">
                            <label
                                >{{ 'detailMain.businessDimensionsLabel' | t }}
                                @if (selectedOrganizationId && !businessDimensionTreeItems) {
                                    <i class="fas fa-circle-notch fa-spin me-2"></i>
                                } @else if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'Please select an organization first.'"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-businessdimensions"
                                [tree]="businessDimensionTreeItems"
                                formControlName="businessDimensionIds"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                                (onChangeIds)="businessDimensionsChanged($event)"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="form-group">
                            <label
                                >{{ 'detailMain.frameworkDimensionsLabel' | t }}

                                @if (selectedOrganizationId && !frameworkDimensionTreeItems) {
                                    <i class="fas fa-circle-notch fa-spin me-2"></i>
                                } @else if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'Please select an organization first.'"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-frameworkdimensions"
                                [tree]="frameworkDimensionTreeItems"
                                formControlName="frameworkDimensionIds"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="removalIds">{{ 'detailMain.removalLabel' | t }}</label>
                                    <cerrix-select
                                        data-uiid="dmdetailmain-removal"
                                        id="removalIds"
                                        formControlName="removalIds"
                                        prettyName="removal types"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="false"
                                        [multiple]="true"
                                        [getDataMethod]="removalRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="sensitivityIds">{{ 'detailMain.sensitivityOfProcessingLabel' | t }}</label>
                                    <cerrix-select
                                        data-uiid="dmdetailmain-sensitivity"
                                        id="sensitivityIds"
                                        formControlName="sensitivityIds"
                                        prettyName="sensitivity of processing"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="false"
                                        [multiple]="true"
                                        [getDataMethod]="sensitivityRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textfield
                                [fieldLabel]="'detailMain.generalArchivePolicyLabel' | t"
                                dataUiid="dmdetailmain-generalarchivepolicy"
                                identifier="generalArchivePolicy"
                                formControlName="generalArchivePolicy"
                                placeholder="Required"
                            ></cerrix-textfield>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-profiling"
                                    [label]="'detailMain.profilingLabel' | t"
                                    formControlName="profiling"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                            <div class="col-12 col-lg-6">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-dataanalytics"
                                    [label]="'detailMain.dataAnalyticsLabel' | t"
                                    formControlName="dataAnalytics"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                @if (recipientConfig) {
                    <generic-list-manager [config]="recipientConfig" idProp="id">
                    </generic-list-manager>
                }
            </div>

            <div class="col-12 col-xl-6">
                @if (sourceDeliveryConfig) {
                    <generic-list-manager [config]="sourceDeliveryConfig" idProp="id">
                    </generic-list-manager>
                }
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'detailMain.stakeholdersTitle' | t }}
                        <i
                            class="far fa-exclamation-circle ms-2"
                            [matTooltip]="
                                'detailMain.stakeholderInheritedTooltip' | t
                            "
                        ></i>
                    </div>
                    <div class="detail-page-card-body padded cerrix-control-sm">
                        <div class="form-group">
                            <label>{{ 'detailMain.dataSubjectsLabel' | t }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datasubjects"
                                [getDataMethod]="dataSubjectsRequest"
                                [value]="processingPurpose.dataSubjectIds"
                                [multiple]="true"
                                [disabled]="true"
                            >
                            </cerrix-select>
                        </div>
                        <div class="form-group">
                            <label for="dataControllerSelect">{{ 'detailMain.dataControllersLabel' | t }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datacontrollers"
                                id="dataControllerSelect"
                                prettyName="data controller(s)"
                                bindValue="ID"
                                [value]="processingPurpose.dataControllerIds"
                                [ngModelOptions]="{ standalone: true }"
                                [multiple]="true"
                                [disabled]="true"
                                [getDataMethod]="dataControllerRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <label for="dataProcessorSelect">{{ 'detailMain.dataSubProcessorsLabel' | t }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datasubprocessors"
                                id="dataProcessorSelect"
                                name="dataProcessorSelect"
                                prettyName="data (sub)processor(s)"
                                bindValue="ID"
                                [value]="processingPurpose.dataProcessorIds"
                                [ngModelOptions]="{ standalone: true }"
                                [multiple]="true"
                                [disabled]="true"
                                [getDataMethod]="dataSubProcessorRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <label for="thirdPartyIds">{{ 'detailMain.thirdPartiesLabel' | t }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-thirdparties"
                                id="thirdPartyIds"
                                formControlName="thirdPartyIds"
                                prettyName="third parties"
                                bindValue="ID"
                                [closeOnSelect]="false"
                                [multiple]="true"
                                [getDataMethod]="thirdPartiesRequest"
                            >
                            </cerrix-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-xl-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'detailMain.dataPrivacyImpactAssessmentTitle' | t }}</div>
                    <div class="detail-page-card-body padded cerrix-control-sm">
                        <div class="row">
                            <div class="col">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-dpiarequired"
                                    [label]="'detailMain.dpiaRequiredLabel' | t"
                                    formControlName="dpiaRequired"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ 'detailMain.mostRecentDpiaLabel' | t }}</label>
                                    <date-input
                                        data-uiid="dmdetailmain-mostrecentdpia"
                                        formControlName="dpiaDate"
                                        [maxDate]="maxDate"
                                    ></date-input>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.dpiaReferenceLabel' | t"
                                        dataUiid="dmdetailmain-dpiareference"
                                        identifier="dpiaReference"
                                        formControlName="dpiaReference"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.latestConclusionDpiaLabel' | t"
                                dataUiid="dmdetailmain-latestconclusiondpia"
                                identifier="dpiaConclusion"
                                formControlName="dpiaConclusion"
                            ></cerrix-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
}
